// import { ICE_EVENTS } from '~~/_core/constants/enums'
let didSetup = false
let prevFrom

export default function ({ store }) {
  // if (process.client) {
  //   window.$nuxt.$emit(ICE_EVENTS.PAGE_SEED_READY)
  // }

  if (!process.client || didSetup) {
    return
  }

  didSetup = true

  window.$nuxt.$on('routeChanged', function (to, from) {
    const fromPath = from.path
    const toPath = to.path

    const isBackNavigation = prevFrom == toPath

    prevFrom = fromPath

    window.$nuxt.$emit('ice:routeChanged', { fromPath, toPath, isBackNavigation })
  })
}
